/* Deduct clearance already supplied after the footer. Native details needs no JS. */
(() => {
  'use strict';
  if (window.Sf26FooterLayout) return;
  let footer, observer, frame = 0, previous = -1;
  const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
  function measure() {
    frame = 0;
    if (!footer?.isConnected || document.body.classList.contains('template-cart')) return;
    if (document.body.matches('.sf-shell-nav-open,.sf-shell-search-open,.has-account-open,.has-cart-opened,[data-sf26-keyboard]')) return;
    const viewport = window.visualViewport;
    if (viewport && Math.abs(viewport.scale - 1) > .02) return;
    const bottom = Math.min(innerHeight, viewport ? viewport.height + viewport.offsetTop : innerHeight);
    let top = bottom;
    document.querySelectorAll('.sf26-dock,#PBarNextFrameWrapper').forEach(element => {
      const style = getComputedStyle(element), rect = element.getBoundingClientRect();
      if (style.position !== 'fixed' || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return;
      if (rect.height > 0 && rect.top < bottom && rect.bottom > 0) top = Math.min(top, Math.max(0, rect.top));
    });
    const height = document.documentElement.scrollHeight;
    const footerEnd = footer.getBoundingClientRect().bottom + window.scrollY;
    const trailing = height > innerHeight + 2 ? Math.max(0, height - footerEnd) : 0;
    const next = Math.ceil(Math.max(10, innerHeight - top + 10 - trailing));
    if (Math.abs(next - previous) > 1) {
      previous = next;
      footer.style.setProperty('--sf26-footer-clearance', `${next}px`);
    }
  }
  function bind() {
    const found = document.querySelector('[data-sf26-footer-organized]');
    if (found !== footer) {
      observer?.disconnect(); footer = found; previous = -1;
      if (footer && 'ResizeObserver' in window) {
        observer = new ResizeObserver(schedule); observer.observe(footer);
      }
    }
    schedule();
  }
  function start() {
    bind();
    for (const name of ['resize','orientationchange','pageshow','load']) window.addEventListener(name, bind, {passive:true});
    window.visualViewport?.addEventListener('resize', schedule, {passive:true});
    document.addEventListener('shopify:section:load', bind);
    new MutationObserver(schedule).observe(document.documentElement, {attributes:true,attributeFilter:['style']});
    new MutationObserver(bind).observe(document.body, {childList:true});
  }
  window.Sf26FooterLayout = {version:'1.0.0'};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
